/** Public origin for bufo images and the manifest. */
export const CDN_BASE: string = import.meta.env.VITE_CDN_BASE ?? '/api/cdn'

export const TURNSTILE_SITEKEY: string = import.meta.env.VITE_TURNSTILE_SITEKEY ?? ''
